/**
 * <TutorAbsentStudentLine> — un élève qui n'est pas venu au live, dans les écrans qui le suivent
 * (molecule).
 *
 * La ligne grisée de l'ancienne prescription (« Inès est élève absent·e ») et du bilan (« … — pas de
 * compte-rendu à faire ») : une seule, sur la ligne de personne du design system (`<PersonRow
 * dimmed>`), son visage estompé, et ce qui en découle pour cet écran en `detail`. Elle ne presse
 * pas : il n'y a rien à faire pour lui.
 */
import React from "react"

import { Card } from "../Card"
import { PersonRow } from "../PersonRow"

const ABSENT = "élève absent·e"

export type TutorAbsentStudentLineProps = {
    name: string
    avatarUrl?: string | null
    /** Ce que l'absence change ici — « pas de compte-rendu à faire ». Absent : « élève absent·e » seul. */
    detail?: string
    testID?: string
}

export function TutorAbsentStudentLine(props: TutorAbsentStudentLineProps) {
    const { name, avatarUrl, detail, testID } = props
    return (
        <Card p="0" testID={testID}>
            <PersonRow
                name={name}
                avatarUrl={avatarUrl}
                caption={detail != null ? `${ABSENT} — ${detail}` : ABSENT}
                dimmed
            />
        </Card>
    )
}
